import login from 'src/i18n/en/pages/login';
import not_verified from 'src/i18n/en/pages/not_verified';
import profile from 'src/i18n/en/pages/profile';
import register from 'src/i18n/en/pages/register';
import reset_password from 'src/i18n/en/pages/reset_password';
import verified from 'src/i18n/en/pages/verified';
import titles from 'src/i18n/en/pages/titles';
import dashboard from 'src/i18n/en/pages/dashboard';
import donorDashboard from 'src/i18n/en/pages/donorDashboard';

const pages = {
  dashboard,
  donorDashboard,
  login,
  not_verified,
  profile,
  register,
  reset_password,
  verified,
  titles,
};

export default pages;
